// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_container__1PIOn","chart":"Chart_chart__2ay2D","title":"Chart_title__3NsNs"};